import api from '@/api'
import {
  SET_ADMINISTRATORNOTICE_LIST,
  SET_HISTORYNOTICE_LIST,
  CHANGE_LOADING_STATE,
  SET_NOTICE_IDS,
} from './mutation-types'

const state = {
  latestNoticeList: [],
  historyNoticeList: [],
  noticeIds: [],
  loading: true,
  type: 1,
}

const mutations = {
  [SET_ADMINISTRATORNOTICE_LIST] (state, payload) {
    state.latestNoticeList = payload
  },
  [SET_HISTORYNOTICE_LIST] (state, payload) {
    state.historyNoticeList = payload
  },
  [SET_NOTICE_IDS] (state, payload) {
    state.noticeIds = payload
  },
  [CHANGE_LOADING_STATE] (state, payload) {
    state.loading = payload
  },
}

const actions = {
  // 获取最新10条管理员公告信息
  async getLatestMessageList ({state, commit}) {
    commit(CHANGE_LOADING_STATE, true)
    const {data} = await api.deployApi.latestAdministratorMessage({type: state.type})
    commit(SET_NOTICE_IDS, data)
    commit(SET_ADMINISTRATORNOTICE_LIST, state.noticeIds)
    commit(CHANGE_LOADING_STATE, false)
  },
  getNewestNoticeNode ({dispatch}) {
    dispatch('getLatestMessageList')
    // .then(() => {
    //   dispatch('getHistoryNoticeList')
    // })
  },
  // 清空数据
  clearNodeData ({commit}) {
    commit(SET_ADMINISTRATORNOTICE_LIST, [])
  },
  // 获取历史信息
  async getHistoryNoticeList ({state, commit}, payload) {
    const {data} = await api.deployApi.getAdminBulletinHistory({bulletinId: payload.bulletinId, type: state.type})
    return data
    // commit(SET_HISTORYNOTICE_LIST, hasHistory)
    // commit(SET_ADMINISTRATORNOTICE_LIST, state.noticeIds)
    // commit(CHANGE_LOADING_STATE, false)
  },
  // 新增管理员公告
  async addAdministratorNotice ({state, dispatch}, payload) {
    const result = await api.deployApi.addAdminBulletin({...payload, type: state.type})
    dispatch('getNewestNoticeNode')
    return result
  },
  // 编辑管理员公告
  async editAdminBulletin ({state, dispatch}, payload) {
    const {bulletinId} = payload
    const result = await api.deployApi.editAdminBulletin({...payload, type: state.type})
    dispatch('getHistoryNoticeList', {bulletinId: bulletinId})
    dispatch('getNewestNoticeNode')
    return result
  },
  // 删除管理员公告
  async deleteAdminBulletin ({state, dispatch}, payload) {
    const result = await api.deployApi.deleteAdminBulletin({...payload, type: state.type})
    dispatch('getNewestNoticeNode')
    return result
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
